// 地区选择组件专用
export default {
    getCityByIds: (allCities: urls.freight.Icity[], ids: number[]) => {
        const selectCities: urls.freight.Icity[] = [];
        allCities.forEach((city: any) => {
            if (ids.indexOf(city.cityId) !== -1) {
                selectCities.push(city);
            }
        });
        return selectCities;
    },
    // 根据全部城市，减去城市1、城市2，获取城市3的数据
    getTargetCities: (allCities: urls.freight.Icity [], cities1: urls.freight.Icity [] = [], cities2: urls.freight.Icity [] = []) => {
        const targetCities: urls.freight.Icity [] = [];
        const cities12 = cities1.concat(cities2);
        const cities12Ids = cities12.map((city) => city.cityId);
        allCities.forEach((city) => {
            if (cities12Ids.indexOf(city.cityId) === -1) {
                targetCities.push(city);
            }
        });
        return targetCities;
    },
    dispatchOptions: [
        { value: 4, label: '4小时内' },
        { value: 8, label: '8小时内' },
        { value: 12, label: '12小时内' },
        { value: 16, label: '16小时内' },
        { value: 20, label: '20小时内' },
        { value: 24, label: '1天内' },
        { value: 48, label: '2天内' },
        { value: 72, label: '3天内' },
        { value: 96, label: '4天内' },
        { value: 120, label: '5天内' },
        { value: 144, label: '6天内' },
        { value: 168, label: '7天内' },
    ],
}
